function getFontsOptions(documentServices) {
  return documentServices.fonts.getFontsOptions()
}

export default {
  getFontsOptions,
}
